<template>
  <div class="range-panel-input">
    <input
      ref="rangeInput"
      class="range-input"
      :value="inputValue"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      @input="onInput"
      :id="id"
    />
    <div class="range-fill" :style="{ width: fillWidth }"></div>
  </div>
</template>

<script>
export default {
  props: {
    inputValue: [Number, String],
    min: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: 100,
    },
    step: {
      type: [Number, String],
      default: 1,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      fillWidth: "0%",
    };
  },
  watch: {
    inputValue(newValue) {
      this.updateFillWidth(newValue);
    },
  },
  mounted() {
    this.updateFillWidth(this.inputValue);
  },
  methods: {
    onInput(event) {
      const newValue = event.target.value;
      this.updateFillWidth(newValue);
      this.$emit("input", newValue);
    },
    updateFillWidth(value) {
      const percentage = ((value - this.min) / (this.max - this.min)) * 100;
      this.fillWidth = `${percentage}%`;
    },
  },
};
</script>

<style scoped>
.range-panel-input {
  position: relative;
  width: 100px;
}

.range-input {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  background-color: var(--white-color);
  border-radius: 4px;
  outline: none;
  position: relative;
}

.range-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  background-color: var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.range-input::-moz-range-thumb {
  width: 10px;
  height: 10px;
  background-color: var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.range-fill {
  position: absolute;
  bottom: 3px;
  left: 0;
  height: 4px;
  background-color: var(--primary-color);
  border-radius: 4px;
  pointer-events: none;
}
</style>
